import * as React from "react";
import { Outlet } from "@tanstack/react-router";
import { ThemeProvider } from "next-themes";
import { useTranslation } from "react-i18next";
import { TRPCProvider } from "@/providers/TRPCProvider";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { DevToolbar } from "@/components/DevToolbar";

/**
 * Root Layout Component
 *
 * This is the root layout for the entire application.
 * It wraps all pages with:
 * - ThemeProvider: next-themes light/dark/system theme (class on <html>)
 * - TRPCProvider: tRPC + React Query context
 * - AuthProvider: Provides authentication context
 * - Toaster: Toast notifications (sonner)
 */
export function RootLayout() {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <TRPCProvider>
        <AuthProvider>
          {/* Main content outlet */}
          <Outlet />

          {/* Floating dev panel (renders only on localhost) */}
          <DevToolbar />

          {/* Global toast notifications */}
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </TRPCProvider>
    </ThemeProvider>
  );
}
